import { render, staticRenderFns } from "./documents-preview.vue?vue&type=template&id=42ca2dd6&scoped=true&"
import script from "./documents-preview.vue?vue&type=script&lang=ts&"
export * from "./documents-preview.vue?vue&type=script&lang=ts&"
import style0 from "./documents-preview.vue?vue&type=style&index=0&id=42ca2dd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ca2dd6",
  null
  
)

export default component.exports